import React, { useState } from 'react';
import { FetchRefreshFunctionParams } from '../../common/useFetch';
import CcCluster from '../../services/models/CcCluster';
import { Col, Form, Select } from 'antd';
import { deliveryTimeOptions } from './emailNotificationsHelper';
import {
    NotifyType,
    notifyError,
    notifyOperationSuccess,
} from '../Notifications/uiNotification';
import CmonConfigService from '../../services/cmon/CmonConfigService';

export default EmailNotificationDeliveryTime;
export type EmailNotificationDeliveryTimeProps = {
    cluster: CcCluster;
    notifications: any;
    onSuccess: (params: FetchRefreshFunctionParams) => Promise<any>;
    emailAddress: string;
    disable: boolean;
};
function EmailNotificationDeliveryTime({
    cluster,
    notifications,
    onSuccess,
    emailAddress,
    disable,
}: EmailNotificationDeliveryTimeProps) {
    const [value, setValue] = useState<number | undefined>();

    const onChangeHandler = async (value: number) => {
        try {
            await CmonConfigService.setnotificationsettings({
                ...notifications,
                cluster_id: cluster.clusterId,
                digest_hour: value,
                email: emailAddress,
            });
            await onSuccess({});
            notifyOperationSuccess({
                type: NotifyType.TOAST,
                title: `Changes saved successfully!`,
                cancelText: 'Close',
            });
            setValue(value);
        } catch (err) {
            notifyError({ type: NotifyType.TOAST, content: err.message });
        }
    };
    return (
        <Col span={8}>
            <Form.Item name="digest" label="Digest delivery time">
                <Select
                    onChange={onChangeHandler}
                    value={value}
                    placeholder="Click here to select"
                    options={deliveryTimeOptions}
                    disabled={disable}
                />
            </Form.Item>
        </Col>
    );
}
